import {ActivatedRoute} from '@angular/router';
import {ROUTE_TOP_BAR_DATA_KEY, RouteTopBar} from '@shared/models/application-tool-bar-menu/route-top-bar';

/**
 * The Meet shell's top bar on every server (MEET-E-31-03, Plan MEET-P-14 Q10): no magic-bar rail and no XatBot pill,
 * and a read-only project pill, because a project switch redirects to `/meet` and out of a live room. Carried by the
 * `meet` route, so it holds Meet's own seeded toolbar on every Meet page, `/meet/calendar` included, though the Calendar
 * application lands there (ITP-E-323-08); Home's when the server sends no Meet application (no OM
 * licence). A file of its own, so `app.routes.ts` pulls no Meet component into the main bundle.
 */
export const MEET_SHELL_TOP_BAR: RouteTopBar = {
  hide: ['MagicBarMenusComponent', 'XatBotMenuComponent'],
  readOnly: ['CurrentProjectComponent'],
  application: 'orbitax-meet'
};

/**
 * The meeting room's own say (MEET-E-53-08, narrowed by MEET-E-53-11, the owner: "move help to top bar only for meet room"):
 * on `/meet/:meetCode` — the check-in and the call — Help sits in the top bar and the floating help launcher hides, so it
 * never covers the room's toolbar. The other Meet pages keep the floating launcher. Added to MEET_SHELL_TOP_BAR, which the
 * `meet` route carries above it.
 */
export const MEET_ROOM_TOP_BAR: RouteTopBar = {
  help: true
};

/**
 * Whether the Meet page `route` shows is hosted in the platform, under the Meet shell's top bar, which already carries
 * the brand, the tabs and the user (ITP-E-338-02, MEET-E-35-01). The standalone meet.orbitax.com app routes the same
 * pages with no such route data, so a page there keeps its own header.
 */
export function isHostedInPlatform(route: ActivatedRoute): boolean {
  return route.pathFromRoot.some(each => each.routeConfig?.data?.[ROUTE_TOP_BAR_DATA_KEY] === MEET_SHELL_TOP_BAR);
}
